<template>
  <div class="vector-decoration">
    <img alt="Vector" src="/img/vector.svg" />
    <img alt="Vector" src="/img/vector-1.svg" />
  </div>

  <div class="structure-symabio">
    <div class="title">
      <img
        class="material-symbols"
        alt="Material symbols"
        src="/img/material-symbols-light-family-history-rounded.svg"
      />
      <div class="title">Structure de SYMABIO</div>
    </div>
    <p class="description">
      Le SYMABIO est un syndicat professionnel régit par le decret NACE 91.11Z
      <br /> <br />
      Tout comme la production biologique, l&#39;industrie agro-alimentaire,
      maillon indispensable de la filière bio, répond aux mêmes exigences
      réglementaires du cahier des charges bio, appliqué de façon identique
      aux TPE et aux grandes entreprises transformant ou distribuant des
      matières premières et des produits transformés certifiés.
    </p>
  </div>
</template>

<script>
export default {
  name: "StructureSymabio",
};
</script>

<style>
.vector-decoration{
  left: 0;
  position: relative;
  top: 120px;
  width: 90px;
  height: max-content;
  display:grid;
}
.structure-symabio {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  /* height: 240px; */
  /* justify-content: space-between; */
  margin: 12vh 8vw;
  /* position: absolute; */
  /* top: 59px; */
  width: 32vw;
}

.structure-symabio .title {
  align-items: center;
  align-self: stretch;
  background-color: transparent;
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
  /* position: relative; */
  width: 100%;
  padding: 8px 0px 24px 0px;

}

.structure-symabio .material-symbols {
  height: 32px;
  /* position: relative; */
  width: 32px;
}

.structure-symabio .title {
  color: #ffffff;
  font-family: "Bw Modelica SS02";
  font-size: 28px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 36px;
  /* margin-top: -1.00px; */
  /* position: relative; */
  white-space: nowrap;
  width: fit-content;
}

.structure-symabio .description {
  align-self: stretch;
  color: #ffffff;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 13px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 20px;
  padding-left: 12px;
  /* position: relative; */
}
@media (max-width:1200px){
  .structure-symabio {
    width: -WEBKIT-FILL-AVAILABLE;
  }
  .vector-decoration{
    left: 0;
    position: relative;
    top: 120px;
    width: 90px;
    height: max-content;
    display:grid;
  }
}
</style>